module.exports = __webpack_public_path__ + "media/audio6.acb2673b.mp4";